export const SET_CATEGORY = "setCategory",
  CATEGORY_RESET = "categoryReset",
  CATEGORY_RESET_STATE = "categoryResetState",
  SET_CATEGORIES = "setCategories",
  CATEGORIES_RESET_STATE = "categoriesReset",
  RESET_STATE = "resetState";
